<template>
  <div class="container ">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div class="card-group">

      <div class="registration-thumbprint-bg"></div>
      <b-card>
        <div slot="header">
          <h1 class="page-header">Complete Your Registration</h1>

        </div>
        <h2 style="text-transform:capitalize" class="page-header2">Hello {{lead.contact_name}}</h2>
        <h4 class="page-header4">Please confirm your information and enter a username and password to continue</h4>
        <dealerInformation ref="dealerInformation" v-bind:isConfirmPage="true"></dealerInformation>
        <!--      </b-card>
       <b-card>
        <div slot="header">
     <h1 class="page-header">End User License Agreement</h1>

   </div>

   <div id="eulaContainer" class="scrollable-panel" @scroll="onScroll">

     <eula></eula>

   </div>
   <div class="form-group p-3">
     <input type="checkbox" href="#" class="btn btn-primary ml-auto" title="Accept" v-model="checked" :disabled="!scrolled" />
     <label>I agree to give you my soul upon death</label>

   </div>-->

        <div class="form-group">

          <div class="d-flex">
            <div class="ml-auto">
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-user fa-lg pr-2" aria-hidden="true"></i></span>

                <input class="username-field" v-validate="'required|min:6'" name="username" type="username" placeholder="Username" ref="username" v-model="username">

              </div>
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-lock fa-lg pr-2" aria-hidden="true"></i></span>

                <input class="password-field" v-validate="'required|min:8|verify_password'" name="password" type="password" placeholder="Password" ref="password" v-model="password">

              </div>
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-lock fa-lg pr-2" aria-hidden="true"></i></span>

                <input class="password-confirmation-field" v-validate="'required|confirmed:password'" name="password_confirmation" type="password" placeholder="Password, Again" data-vv-as="password" v-model="passwordConfirm">
              </div>

            </div>
          </div>
        </div>
        <b-list-group style="min-width:100%" v-if="validateErrors.any()">
          <b-list-group-item class="py-2" variant="danger" v-for="err in validateErrors.items" :key="err.id"> {{ err.msg }} </b-list-group-item>
          <b-list-group-item class="py-2" variant="danger" v-if="customError">{{customError}}</b-list-group-item>
        </b-list-group>
        <div slot="footer" class="d-flex">

          <button class="btn btn-primary ml-auto proceed-btn" :disabled="!checked" @click="proceedBtnClick">Proceed</button>
        </div>
      </b-card>

    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>

import Vue from 'vue'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import loading from 'vue-full-loading'
import Store from '@/store'
import VueCookies from 'vue-cookies'
import tokenexpiration from '@/shared/tokenexpiration'

import dealerInformation from '@/views/DealerInformation'
import eula from '@/views/mDrive/EULA'
Vue.use(VeeValidate)

Vue.use(VueCookies)

VeeValidate.Validator.extend('verify_password', {
  getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp('(?=^.{8,25}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*')
    return strongRegex.test(value)
  }
})

export default {
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      userGuid: '',
      lead: {},
      eulaText: 'file not found',
      checked: true,
      password: '',
      passwordConfirm: '',
      username: '',
      scrolled: false,
      customError: ''
    }
  },
  components: {
    dealerInformation,
    eula,
    loading
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  created () {
    this.userGuid = this.$route.query.lead
    this.boolLoading = true
  },
  mounted () {
    var makes = this.$refs.dealerInformation.lead.makes
    this.boolLoading = true
    axios.get('/api/mDrive/GetLead?lead=' + this.userGuid)
      .then(response => {
        this.boolLoading = false
        if (response.data === undefined || response.data === null) {
          this.lead = {}
        } else {
          this.$refs.dealerInformation.lead = response.data
          this.lead = this.$refs.dealerInformation.lead
        }
      }).catch(error => {
        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
  },
  methods: {
    displayError: function (error) {
      var self = this
      self.boolLoading = false
      try {
        var code = parseInt(error.response.status)
        if (code === 401 || code === 403 || (code >= 500 && code < 600)) {
          self.errMsg = ((error !== undefined && error.response !== undefined && error.response.data !== undefined) ? error.response.data : error)
        } else {
          self.errMsg = '(' + error.response.status + ') ' +
              ((error !== undefined && error.response !== undefined && error.response.data !== undefined) ? error.response.data : error)
        }
      } catch (e) { self.errMsg = error.message }

      self.showDismissibleAlert = true
    },

    proceedBtnClick () {
      this.boolLoading = true
      var self = this

      if (this.password != this.passwordConfirm) {
        this.boolLoading = false
        this.customError = 'Passwords must match'
        return
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          var obj = {
            DEALER_NAME: this.$refs.dealerInformation.lead.dealer_name,
            ADDRESS1: this.$refs.dealerInformation.lead.address1,
            ADDRESS2: this.$refs.dealerInformation.lead.address2,
            CITY: this.$refs.dealerInformation.lead.city,
            STATE: this.$refs.dealerInformation.lead.state,
            ZIP: this.$refs.dealerInformation.lead.zip,
            PHONE: this.$refs.dealerInformation.lead.phone,
            CONTACT_FIRSTNAME: this.$refs.dealerInformation.lead.contact_firstname,
            CONTACT_LASTNAME: this.$refs.dealerInformation.lead.contact_lastname,
            CONTACT_POSITION: this.$refs.dealerInformation.lead.contact_position,
            CONTACT_PHONE: this.$refs.dealerInformation.lead.contact_phone,
            DEALER_URL: this.$refs.dealerInformation.lead.dealer_url,
            CONTACT_EMAIL: this.$refs.dealerInformation.lead.contact_email,
            GUID: this.userGuid,
            PASSWORD: this.password,
            SELECTED_MAKES: this.$refs.dealerInformation.lead.selected_makes,
            USERNAME: this.username
          }
          axios.post('/api/mdrive/completeRegistration', obj)
            .then(async response => {
              var loginInfo = {
                account: response.data,
                login: this.username,
                password: this.password
              }
              var error = await self.$loginUser(loginInfo)

              if (error) {
                this.displayError(error)
              } else {
                // redirect to wizard
                self.$router.push('/mDriveEnrollment')
              }
            }).catch(error => {
              this.displayError(error)
            })
        } else {
          // alert('Please correct errors first');
          self.boolLoading = false
          self.errMsg = 'Please correct errors first'
          self.dismissibleType = 'danger'
          self.showDismissibleAlert = true

          setTimeout(function () {
            self.showDismissibleAlert = false
            self.errMsg = ''
          }, 8000)
        }
      })
    },

    onScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.scrolled = true
      }
    }
  }
}

</script>

<style scoped>
  .card {
    background: transparent;
  }
  .registration-thumbprint-bg {
    width: 100%;
    height: calc(100% - 237px);
    background-image: url(https://www.marketscan.com/Portals/0/blue-thumbprint-5.png);
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    margin: 0;
    top: 161px;
    left: 0;
    z-index: -1;
  }
  .scrollable-panel {
    background: white;
    border: 1px solid #c2cfd6;
    padding: 20px !important;
  }
  .page-header {
    font-family: Calibri, sans-serif;
    font-weight: bold;
    color: #231f20;
  }

  .page-header2 {
    font-family: Calibri, sans-serif;
    font-weight: 100;
    color: #231f20;
    width: calc(100% - 30px);
    margin-left: 15px;
  }
  .container-registration {
    width: 80vw !important;
    margin-left: auto;
    margin-right:auto;
  }
  .page-header4 {
    font-family: Calibri, sans-serif;
    font-weight: 100;
    color: #231f20;
    width: calc(100% - 30px);
    margin-left: 15px;
  }

  body > div > div.card-group > div:nth-child(1) > div.card-body > h4 {
    margin-bottom: 25px;
  }

  .scrollable-panel {
    max-height: 45vh;
    overflow: auto;
    padding: 5px;
  }

  body > div > div.card-group > div:nth-child(2) > div.card-body {
    padding: 1.25rem calc(1.25rem + 15px);
  }

  body > div > div.card-group > div:nth-child(2) > div.card-body > div.form-group.p-3 {
    padding-left: 0 !important;
  }
  .input-group {
      width: 300px;
  }

  .password-field {
    height: 35px;
    padding: 6px;
    margin-bottom: 1rem;
    width:250px;
  }

  .username-field {
    height: 35px;
    padding: 6px;
    margin-bottom: 1rem;
    width: 250px;
  }

  .password-confirmation-field {
    height: 35px;
    padding: 6px;
    width: 250px;
  }

  .fa-lock {
    margin-right: 10px;
    margin-top: 12px;
  }

  .fa-user {
    margin-right: 10px;
    margin-top: 12px;
  }

  .proceed-btn {
    border-radius: .25rem;
  }

  .card-footer {
    padding: 1.25rem calc(1.25rem + 15px);
  }
</style>



// WEBPACK FOOTER //
// src/views/mDrive/mDriveRegistration.vue